import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { STATUSPAGE } from '@repo/ui';
import './styles.css';

interface KolbConfirmationModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
  isDistributingAll: boolean;
  course?: {
    name: string;
    semester: string;
    organizationName: string;
  };
  groupsCount?: number;
  studentsCount?: number;
  loading?: STATUSPAGE;
}

export const KolbConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  isDistributingAll,
  course,
  groupsCount = 0,
  studentsCount = 0,
  loading,
}: KolbConfirmationModalProps) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (!isDistributingAll || !isOpen) return;

    setCountdown(5);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isDistributingAll, isOpen]);

  if (!isDistributingAll) {
    return (
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Confirmar Distribuição</ModalHeader>
        <ModalBody>
          <p>Tem certeza que deseja distribuir os estudantes por Kolb?</p>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Cancelar
          </Button>
          <Button
            color='primary'
            onClick={onConfirm}
            disabled={(loading ?? STATUSPAGE.INITIAL) === STATUSPAGE.LOADING}
          >
            {(loading ?? STATUSPAGE.INITIAL) === STATUSPAGE.LOADING
              ? 'Distribuindo...'
              : 'Confirmar'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirmar Distribuição</ModalHeader>

      <ModalBody>
        <p className='text-muted mb-3'>
          Você está prestes a distribuir estudantes em <strong>todos os grupos</strong> deste curso.
        </p>

        <div className='confirmation-details'>
          <div className='detail-row'>
            <span className='label'>Curso:</span>
            <span>{course?.name} - {course?.semester}</span>
          </div>
          <div className='detail-row'>
            <span className='label'>Grupos Afetados:</span>
            <span className='value'>{groupsCount} grupos</span>
          </div>
          <div className='detail-row'>
            <span className='label'>Estudantes:</span>
            <span className='value'>{studentsCount} estudantes</span>
          </div>
        </div>

        <div className='mt-4 pt-3 border-top'>
          <small className='text-muted'>
            <strong>Atenção:</strong>
            <ul className='mt-2 mb-0'>
              <li>Grupos já com estudantes serão rebalanceados</li>
              <li>Estudantes sem perfil Kolb serão ignorados</li>
            </ul>
          </small>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          color='secondary'
          onClick={toggle}
          disabled={(loading ?? STATUSPAGE.INITIAL) === STATUSPAGE.LOADING}
        >
          Cancelar
        </Button>
        <Button
          color='primary'
          onClick={onConfirm}
          disabled={(loading ?? STATUSPAGE.INITIAL) === STATUSPAGE.LOADING}
        >
          {(loading ?? STATUSPAGE.INITIAL) === STATUSPAGE.LOADING
            ? 'Distribuindo...'
            : 'Confirmar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
